import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UsuarioService {
  storage = null;
  accessToken = '';
  headers = {};
  constructor(private http: HttpClient) {
    this.storage = localStorage.getItem('at');

    if (this.storage) {
      const decode = atob(this.storage);
      this.accessToken = JSON.parse(decode);
    }

    this.headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
    };
  }

  updateToken(data: any): Observable<any> {
    this.storage = localStorage.getItem(data);
    const decode = atob(data);
    this.accessToken = JSON.parse(decode);
    return;
  }

  getUser(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_one',
        data: {
          id_usuario: id_usuario
        },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/users`, body);
  }

  register(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/users`, body);
  }
  updateUser(data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'update',
        data: data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/users`, body);
  }

  getCompany(id_empresa_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_one_eu',
        data: {
          id_empresa_usuario: id_empresa_usuario,
        },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
  addCompany(_data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add_eu',
        data: _data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
  updateCompany(_data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'update_eu',
        data: _data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
  updateIsCompany(_data: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'update_is_company',
        data: _data,
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
  getDemo(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_one_demo',
        data: { id_usuario: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }

  getInfoDemos(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'validate_demo',
        data: { id_usuario: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/marketplaces`, body);
  }


  addDemo(id_usuario: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'add_demo',
        data: { id_usuario: id_usuario },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
  private handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse);
  }

  getVisitantes(id_evento: any): Observable<any> {
    let body = {
      request_data: {
        type_action: 'get_all_v',
        data: { id_evento: id_evento },
      },
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: this.accessToken,
      },
    };

    return this.http.post(`${apiUrl.BASE_URL}/usuarios`, body);
  }
}
